import { Box, Stack } from '@mui/material'
import { useState } from 'react'
import { AccordionTransition } from '../../common/AccordionTransition'
import { FilesFieldCard } from '../../feat/editItinerary/components/filesFieldCard'
import { TextFieldCard } from '../../feat/editItinerary/components/textFieldCard'
import { Expand } from '../../home/components/expand'
import i18n from '../../i18n/i18next'
import { useFormatValue } from '../hooks/useFormatValue'
import { EditButton } from './editButton'
import { UsersList } from './usersList'
interface IParkingCarBodyProps {
    id?: string
    data: any
    renderOptions: IParkingCarBodyOptions
}

interface IParkingCarBodyOptions {
    listFieldId: number
    icon?: string
    editPageId?: number
    userListKey: string
    driversListKey: string
}
export const ParkingCarBody = ({
    id,
    data,
    renderOptions,
}: IParkingCarBodyProps) => {
    const { formatValue } = useFormatValue()
    const [chevroClickOpen, setChevroClickOpen] = useState<boolean>(false)

    const userList = () => {
        const hideUserList =
            data?.[renderOptions.userListKey]?.length === 0 &&
            data?.[renderOptions.driversListKey]?.length === 0

        return (
            <>
                <Stack justifyContent={'space-between'} direction={'row'}>
                    {hideUserList ? (
                        <div />
                    ) : (
                        <Box
                            height={'24px'}
                            onClick={() => {
                                setChevroClickOpen(!chevroClickOpen)
                            }}
                        >
                            <Expand expanded={chevroClickOpen} />
                        </Box>
                    )}

                    <EditButton
                        id={id}
                        data={data}
                        renderOptions={{ pageId: renderOptions.editPageId }}
                    />
                </Stack>
                {!hideUserList && (
                    <AccordionTransition open={chevroClickOpen}>
                        <UsersList
                            id={id}
                            data={data}
                            renderOptions={{
                                users: renderOptions.driversListKey,
                                hideChat: true,
                            }}
                        />
                        <UsersList
                            id={id}
                            data={data}
                            renderOptions={{
                                users: renderOptions.userListKey,
                                hideChat: true,
                            }}
                        />
                    </AccordionTransition>
                )}
            </>
        )
    }

    return (
        <Stack spacing={'16px'}>
            <TextFieldCard
                id={id}
                description={i18n.t('edit-itinerary.fields.905')}
                text={data.entry ? formatValue(data.entry, 'datetime') : null}
            />
            <TextFieldCard
                id={id}
                description={i18n.t('edit-itinerary.fields.906')}
                text={data.exit ? formatValue(data.exit, 'datetime') : null}
            />
            <TextFieldCard
                id={id}
                description={i18n.t('edit-itinerary.fields.909')}
                text={data.number_plate}
            />
            <TextFieldCard
                id={id}
                description={i18n.t('edit-itinerary.fields.912')}
                text={data.notes}
            />

            <FilesFieldCard
                id={id}
                description={i18n.t('edit-itinerary.fields.documents')}
                files={data.documents}
            />
            {userList()}
        </Stack>
    )
}
